<template>
  <div class="dashboard-block" v-if="$paymentsModuleEnabled">
    <h2>Admin Options</h2>

    <div class="panel">
      <div class="panel-body">
        <div class="row" v-if="$requestFormConfig.show_commission && monetaryCurrency && booking.budget_per_star > 0">
          <div class="col-sm-4">
            <h3>{{ clientName }} Commission</h3>
          </div>
          <div class="col-sm-8">
            <div :class="$hasErrorClass($v.stateCommissionRate, 'form-group')">
              <div class="row">
                <div class="col-sm-5 col-md-5">
                  <div class="input-group">
                    <input
                      name="commission_rate"
                      type="number"
                      class="form-control"
                      v-model="$v.stateCommissionRate.$model"
                      :disabled="!!stateCommissionDollar"/>

                    <span class="input-group-addon"><i class="fa fa-percent"></i></span>
                  </div>

                  <vuelidate-help label="Commission rate" :field="$v.stateCommissionRate"/>
                </div>
                <div class="col-sm-1 col-md-1" style="padding: 0; padding-top: 10px; text-align: center;">OR</div>
                <div class="col-sm-5 col-md-5">
                  <div :class="$hasErrorClass($v.stateCommissionDollar, 'form-group')">
                    <div class="input-group">
                      <span class="input-group-addon"><i class="fa fa-usd"></i></span>

                      <input
                        name="commission_dollar"
                        type="text"
                        class="form-control"
                        v-model="stateCommissionDollar"
                        :disabled="!!stateCommissionRate"
                      />
                    </div>

                    <vuelidate-help label="Commission dollar" :field="$v.stateCommissionDollar"/>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

        <div v-if="$userIsGlobalAdmin && regionOptions.length > 1" class="row">
          <div class="col-xs-12" >
            <h3>Region</h3>
            <selectize
              class="selectize selectize-single"
              name="timezone"
              v-model="stateRegion"
              :options="regionOptions">
            </selectize>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-6">
            <ladda-button
              class="btn btn-success m-t-label"
              :click="handleSaveCommissionRateCallback">
              Save Changes
            </ladda-button>
          </div>
        </div>

      </div>
    </div>

    <booking-history
      v-if="$userIsAdmin"
      :booking="booking"/>
  </div>
</template>

<script>
import { BookingStateMapper as stateMapper } from 'pickstar-common'
import { mapActions } from 'vuex'
import { helpers } from 'mixins/bookings'
import BookingHistory from './BookingHistory'
import Selectize from '../ext/codium/CodiumSelectize'
import { notify } from 'utils'
import { decimal, numeric, between } from 'vuelidate/lib/validators'
import VuelidateHelp from '../misc/VuelidateHelp'

export default {

  validations: {
    stateCommissionRate: {
      numeric,
      between: between(0, 100)
    },
    stateCommissionDollar: {
      decimal
    }
  },

  mixins: [stateMapper, helpers],

  props: {
    booking: {
      required: true,
      type: Object
    }
  },

  components: {
    BookingHistory,
    Selectize,
    VuelidateHelp
  },

  data () {
    return {
      regionOptions: []
    }
  },

  mounted () {
    this.getRegions().then(response => {
      this.regionOptions = response.data.map(item => {
        return {
          id: item.id,
          text: item.name
        }
      })
    })
  },

  computed: {
    stateRegion: {
      get () {
        return this.booking.region_id
      },
      set (value) {
        this.propertyMutator({ property: 'region_id', value })
      }
    }
  },

  methods: {
    ...mapActions('booking', ['updateBookingAdminOptions']),
    ...mapActions('booking', {
      propertyMutator: 'setBookingProperty'
    }),
    ...mapActions('region', ['getRegions']),

    handleSaveCommissionRateCallback () {
      if (this.$v.$invalid) {
        this.$v.$touch()
        notify.error(`Some fields failed validation. Please fix them and try again`)
        return Promise.resolve()
      }
      return this.updateBookingAdminOptions({
        id: this.booking.id,
        commissionRate: this.booking.commission_rate,
        commissionDollar: this.stateCommissionDollar,
        commissionType: this.stateCommissionDollar ? 'dollar' : 'rate',
        regionId: this.booking.region_id
      })
    }
  }
}
</script>
